import { render, staticRenderFns } from "./StepMedia.vue?vue&type=template&id=c318cc64&scoped=true&"
import script from "./StepMedia.vue?vue&type=script&lang=js&"
export * from "./StepMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c318cc64",
  null
  
)

export default component.exports